export default "__VITE_ASSET__8d1b958b__"